<template>
  <div class="container-fluid" :class="{ 'container-show': isScrolled }">
    <!-- 上部文字介绍区域 -->
    <div class="tit-message row mb-4">
      <div class="col-12 bg-light p-5 rounded">
        <h2>享乐无尽・休闲体验</h2>
        <p>
          以定制化管家服务注入温度，AI智慧入住开启高效旅程。艺廊空间延伸城市探索维度，联动在地艺术家呈现流动美学，从智能场景到人文体验，我们以专业洞察力编织旅行灵感，让每个停留时刻都成为值得珍藏的生活诗篇。
        </p>
      </div>
    </div>

    <!-- 下部手风琴卡片区域 -->
    <div class="row">
      <div class="col-12">
        <div :class="[
          'accordion-container',
          isMobile ? 'vertical-accordion' : 'horizontal-accordion',
        ]">
          <div v-for="(item, index) in accordionItems" :key="item.id || index" :class="[
            'accordion-panel',
            { active: item.isOpen },
            isMobile ? 'vertical-panel' : 'horizontal-panel',
          ]" @click="selectItem(index)">
            <div class="panel-content">
              <img :src="item.image" alt="Accordion Image" class="img-fluid" />
              <div class="overlay" v-if="!item.isOpen">
                <h3 class="overlay-title">{{ item.title }}</h3>
              </div>

              <!-- 展开时显示的内容区域 -->
              <div class="expanded-content" v-if="item.isOpen">
                <div class="content-wrapper">
                  <h3 class="expanded-title">{{ item.title }}</h3>
                  <p class="expanded-description">{{ item.description }}</p>
                  <router-link to="/entertainment" style="color: white"><button
                      class="detail-btn">查看详情</button></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalAccordion",
  data() {
    return {
      accordionItems: [
        {
          id: 1,
          title: "享乐无尽·休闲体验",
          image: "https://picsum.photos/800/600?random=1",
          description:
            "以定制化管家服务注入温度，AI智慧入住启动高效旅程。艺廊空间延伸城市探索维度，联动在地艺术家呈现流动美学。",
          isOpen: true,
        },
        {
          id: 2,
          title: "美食探索·味蕾盛宴",
          image: "https://picsum.photos/800/600?random=2",
          description:
            "主厨团队由米其林星级名厨率领，融合在地食材与创新技法，打造感官飨宴。24小时餐饮服务贯穿时光轴线。",
          isOpen: false,
        },
        {
          id: 3,
          title: "奢华住宿·舒适空间",
          image: "https://picsum.photos/800/600?random=3",
          description:
            "客房空间以现代主义设计美学为基调，全景落地窗引入城市天际线或自然景观。智能空间管理系统实现语音控制。",
          isOpen: false,
        },
        {
          id: 4,
          title: "健康活力·健身中心",
          image: "https://picsum.photos/800/600?random=4",
          description:
            "顶级健身设备搭配私人教练指导，室内泳池与SPA中心提供全方位放松体验。24小时开放的健身空间，满足您的健身需求。",
          isOpen: false,
        }
      ],
      selectedItem: {},
      isMobile: window.innerWidth < 768,
      isScrolled: false,
      scrollThreshold: 800,
    };
  },
  mounted() {
    // 初始化选中项
    this.selectedItem = this.accordionItems.find((item) => item.isOpen) || {};

    // 添加窗口大小变化监听
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop >= this.scrollThreshold && !this.isScrolled) {
        this.isScrolled = true;
      }
    },

    selectItem(index) {
      // 更新选中项数据
      this.selectedItem = this.accordionItems[index];

      // 重置所有面板状态
      this.accordionItems.forEach((item, i) => {
        item.isOpen = i === index;
      });
    },
    openDetail(item) {
      // 这里可以添加打开详情页的逻辑
      console.log("打开详情:", item);
      // 示例：可以使用Vue Router导航到详情页
      // this.$router.push({ name: "entertainment", params: { id: item.id } });
      // this.$router.push("/entertainment");
    },
    handleResize() {
      // 检测屏幕尺寸变化，更新布局状态
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style scoped lang="scss">
// 定义响应式断点
$breakpoint-mobile: 768px;
$primary-color: #1e88e5;

.container-fluid {
  font-family: 'font1', sans-serif;     
  margin-bottom: 5vh;
  padding-bottom: 20px;
  transform: scale(0);
  transition: all .5s linear;
}

.container-show {
  transform: scale(1);

}

.tit-message {
  margin-bottom: 0 !important;

  div,
  h2,
  p {
    background-color: transparent !important;
  }
}

.accordion-container {
  width: 75%;
  margin: auto;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  // 水平手风琴布局（桌面端）
  &.horizontal-accordion {
    display: flex;
    height: 60vh;

    .horizontal-panel {
      flex: 1;
      transition: flex 0.5s ease;
      position: relative;
      cursor: pointer;

      &.active {
        flex: 3;
      }
    }
  }

  // 垂直手风琴布局（移动端）
  &.vertical-accordion {
    display: block;

    .vertical-panel {
      height: 150px;
      transition: height 0.5s ease;
      position: relative;
      cursor: pointer;

      &.active {
        height: 300px;
      }
    }
  }
}

.panel-content {
  position: relative;
  height: 100%;
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  // 未展开时的遮罩层
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7));
    display: flex;
    align-items: flex-end;
    padding: 20px;
    transition: opacity 0.3s ease;

    .overlay-title {
      color: white;
      margin: 0;
      font-size: 1.2rem;
      font-weight: 500;
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    }
  }

  // 展开时隐藏遮罩层
  .active & .overlay {
    opacity: 0;
    pointer-events: none;
  }

  // 展开时图片放大效果
  .active & img {
    transform: scale(1.05);
  }

  // 展开时显示的内容区域
  .expanded-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    padding: 20px 30px 40px;
    color: white;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.4s ease 0.1s;

    .content-wrapper {
      max-width: 800px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        text-align: left;
      }
    }

    .expanded-title {
      color: white;
      font-size: 1.8rem;
      margin-bottom: 10px;
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    }

    .expanded-description {
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 20px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }

    .detail-btn {
      background-color: $primary-color;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 5px;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;

      &:hover {
        background-color: darken($primary-color, 10%);
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      }
    }
  }

  // 展开时显示内容区域
  .active & .expanded-content {
    opacity: 1;
    transform: translateY(0);
  }
}

// 移动端适配
@media (max-width: $breakpoint-mobile) {
  .accordion-container {
    width: 95%;
  }

  .expanded-content {
    padding: 15px 20px 30px;

    .expanded-title {
      color: white;
      font-size: 1.5rem;
    }

    .expanded-description {
      font-size: 0.9rem;
    }

    .detail-btn {
      padding: 8px 16px;
      font-size: 0.9rem;
    }
  }
}
</style>
